<mat-sidenav-container>
  <!-- TODOEVENTUALLY MMD - connecting...?? -->
<!--  <div class="connecting" *ngIf="!backend.connected">-->
<!--    <div class="connecting-text">CONNECTING</div>-->
<!--    <div class="connecting-info">If this problem persists, please reload the page.</div>-->
<!--  </div>-->
  <router-outlet></router-outlet>
</mat-sidenav-container>
